import gsap from 'gsap';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { ScrollItem__Default } from './ScrollItem__Default';

class ScrollItem__Footer extends ScrollItem__Default {
  tick = 0;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    const circle = GetBy.selector('.icon--logo-footer svg', __link)[0];
    this.rotations = GetBy.class('__rotate', circle);
    for (let i = 0; i < this.rotations.length; i++) {
      const rot = this.rotations[i];
      rot.style.transformOrigin = 'center center';
    }
  }

  loop() {
    this.tick += .1 - Scroll.speed * .3;

    for (let i = 0; i < this.rotations.length; i++) {
      const sign = i % 2 === 0 ? -1 : 1;
      const rot = this.rotations[i];
      rot.style.transform = `rotateZ(${sign * this.tick}deg)`;
    }
  }
}

Scroll._registerClass('Footer', ScrollItem__Footer);